document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.list-info-panel__section');
  const total = items.length;
  let current = 0;

  function nextItem() {
    current++;
    if (current > total) current = 1;

    const list = document.querySelector(
      '.list-info-panel__btn--content[data-num="' + current + '"]'
    );
    if (list) {
      const id = list.getAttribute('data-id');
      activateContent(id);
    }
  }

  nextItem();
  const itemsInterval = setInterval(nextItem, 4000);

  function activateList(slug) {
    if (slug) {
      const id = slug + '-children';
      const controlled = document.getElementById(id);
      const open = true;

      document.querySelectorAll('.list-info-panel__btn--list').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });

      document
        .querySelectorAll('.list-info-panel__list > li > ul')
        .forEach((el) => {
          el.setAttribute('aria-hidden', 'true');
          el.hidden = true;
        });

      if (controlled) {
        controlled.setAttribute('aria-hidden', open ? 'false' : 'true');
        controlled.hidden = !open;
      }

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  function activateContent(slug) {
    if (slug) {
      const id = slug + '-content';
      const controlled = document.getElementById(id);
      const parent = controlled.closest('ul');
      const open = true;

      document
        .querySelectorAll('.list-info-panel__btn--content')
        .forEach((el) => {
          el.classList.remove('list-info-panel__btn--active');
        });

      document.querySelectorAll('.list-info-panel__section').forEach((el) => {
        if (el.getAttribute('id') !== id) {
          el.setAttribute('aria-hidden', 'true');
          el.hidden = true;
        }
      });

      if (controlled) {
        controlled.setAttribute('aria-hidden', open ? 'false' : 'true');
        controlled.hidden = !open;
      }

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      activateList(parent.getAttribute('data-id'));
    }
  }

  document.querySelectorAll('.list-info-panel__btn--list').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('data-id');
      activateList(id);
      activateContent(id);
      clearInterval(itemsInterval);
      e.preventDefault();
    });
  });

  document.querySelectorAll('.list-info-panel__btn--content').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('data-id');
      el.classList.add('list-info-panel__btn--active');
      activateContent(id);
      clearInterval(itemsInterval);
      e.preventDefault();
    });
  });
});
